import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core/styles";

import Modal from "@material-ui/core/Modal";
import Fade from "@material-ui/core/Fade";
import Button from "@material-ui/core/Button";
import IconButton from "@material-ui/core/IconButton";
import DeleteIcon from "@material-ui/icons/Delete";
import { connect } from "react-redux";
import Paper from "@material-ui/core/Paper";
import TextField from "@material-ui/core/TextField";
import { Tooltip } from "@material-ui/core";
import OwnField from "./ModalField";
import { defaultPasscodeTheme } from "../../../../../constants/passCodeUtils";
import { toggleInfoModal, closeTicket, setOrderId } from "../../../../../actions/projectmail";

const useStyles = makeStyles(theme => ({
  ...defaultPasscodeTheme(theme),
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  paper: {
    width: "750px",
    backgroundColor: theme.palette.background.paper,
    border: "2px solid #000",
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    maxHeight: "927px",
    overflowY: "auto",
  },
  closePaper: {
    width: "650px",
    backgroundColor: theme.palette.background.paper,
    border: "2px solid #000",
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
  },
  paddingTop: {
    paddingTop: theme.spacing(2),
  },
  marginTop: {
    marginTop: theme.spacing(-1),
  },
  flexGrow: {
    flexGrow: 1,
  },
  closeticket: {},
  header: {
    font: "bold",
    fontSize: "16px",
    width: "100%",
    textAlign: "center",
  },
  orderField: {
    width: "100%",
    margin: theme.spacing(1, 1, 1, 1),
  },
  button: {
    padding: theme.spacing(1),
    paddingTop: theme.spacing(2),
  },
  center: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  patternValidate: {
    "&:invalid": {
      background: "#F08080",
    },
  },
}));

export const InfoModalComponent = ({ infoTicket, open, close, closeTicketFn, translate, setOrderIdFn }) => {
  const [ownTicket, setOwnTicket] = useState(infoTicket);
  const [openModal, setOpenModal] = useState(false);
  const [newOrderID, setNewOrderID] = useState(infoTicket ? infoTicket.orderID : "");
  const [disableButton, setDisableButton] = useState(false);
  const [saved, setSaved] = useState(false);

  const handleClose = () => {
    close();
  };

  useEffect(() => {
    if (infoTicket !== ownTicket && infoTicket) {
      setOwnTicket(infoTicket);
      if (infoTicket.orderID !== -1) setNewOrderID(infoTicket.orderID);
    }
  }, [infoTicket, ownTicket, setOwnTicket]);

  const classes = useStyles();
  return (
    open === true &&
    ownTicket !== undefined && [
      <Modal key="inner-info-modal" open={open} className={classes.modal} onClose={handleClose}>
        <Fade in={open}>
          <div className={classes.paper}>
            <div className={classes.paddingTop} />
            <div className={classes.header}>{translate.ticketData}</div>
            <div className={classes.paddingTop} />
            <Paper elevation={6}>
              <div className={classes.inline}>
                <OwnField translationKey="EmailTicketSystemOwner" value={ownTicket.owner} />
                <OwnField translationKey="Priority" value={ownTicket.priority} />
              </div>
              <div className={classes.lineBreak} />
              <div className={classes.inline}>
                <OwnField translationKey="firstName" value={ownTicket.customerFirstName} />
                <OwnField translationKey="lastName" value={ownTicket.customerLastName} />
              </div>
              <div className={classes.lineBreak} />
              <div className={classes.inline}>
                <OwnField translationKey="customer" value={ownTicket.customer} />
                <OwnField translationKey="externalId" value={ownTicket.externalID} />
              </div>
              <div className={classes.lineBreak} />
              <div className={classes.inline}>
                <OwnField translationKey="lastUpdateTime" value={ownTicket.lastUpdatedAt} date />
              </div>
              <div className={classes.lineBreak} />
            </Paper>
            <div className={classes.paddingTop} />
            <div className={classes.header}>{translate.home2Data}</div>
            <div className={classes.paddingTop} />
            <Paper elevation={6}>
              <div className={classes.lineBreak} />
              <div className={classes.inline}>
                <OwnField translationKey="operator" value={ownTicket.operator} />
                <OwnField translationKey="additionalOperator" value={ownTicket.additionalOperator} />
              </div>
              <div className={classes.lineBreak} />
              <div className={classes.inline}>
                <OwnField translationKey="eventStartTime" value={ownTicket.eventStartTime} date />
              </div>
              <div className={classes.inline}>
                <OwnField translationKey="eventEndTime" value={ownTicket.eventEndTime} date />
              </div>
              <div className={classes.lineBreak} />
              <div className={classes.inline}>
                <OwnField translationKey="orderProduct" value={ownTicket.orderProduct} />
                <OwnField translationKey="orderStatus" value={ownTicket.orderStatus} />
              </div>
              <div className={classes.lineBreak} />
              <div className={classes.inline}>
                <OwnField translationKey="internalNotes" value={ownTicket.notes} note />
              </div>
              <div className={classes.lineBreak} />
              <div className={classes.inline}>
                <OwnField translationKey="externalNotes" value={ownTicket.externalNotes} note />
              </div>
              <div className={classes.lineBreak} />
              <div className={classes.inline}>
                <TextField
                  id="order-id-inputField"
                  label={translate.setOrderId}
                  className={`${classes.orderField} `}
                  padding="normal"
                  value={newOrderID || ""}
                  onChange={e => {
                    setNewOrderID(e.target.value);
                    setSaved(false);
                    const regex = new RegExp("^[a-zA-Z0-9]{0,8}$");
                    setDisableButton(!regex.test(e.target.value));
                  }}
                  inputProps={{ className: classes.patternValidate, pattern: "^[a-zA-Z0-9]{0,8}$" }}
                />
                <div className={classes.button}>
                  <Button
                    onClick={async () => {
                      setSaved(false);
                      setDisableButton(true);
                      await setOrderIdFn(ownTicket.id, newOrderID);
                      setDisableButton(false);
                      setSaved(true);
                    }}
                    variant="contained"
                    color="primary"
                    disabled={disableButton}
                  >
                    {translate.saveButton}
                  </Button>
                  {saved && <div className={classes.center}>{translate.saved}!</div>}
                </div>
                <div className={`${classes.button} ${classes.marginTop}`}>
                  <Tooltip title={translate.deleteButton} enterDelay={500} placement="top">
                    <IconButton
                      color="secondary"
                      disabled={disableButton}
                      onClick={async () => {
                        setSaved(false);
                        setDisableButton(true);
                        setNewOrderID("");
                        await setOrderIdFn(ownTicket.id, -1);
                        setDisableButton(false);
                        setSaved(true);
                      }}
                    >
                      <DeleteIcon />
                    </IconButton>
                  </Tooltip>
                </div>
              </div>
            </Paper>
            <div className={classes.paddingTop}>
              <div className={classes.inline}>
                <Button onClick={() => setOpenModal(true)} variant="contained" color="secondary">
                  {translate.closeTicket}
                </Button>
                <div className={classes.flexGrow} />
                <Button variant="contained" onClick={() => close()}>
                  {translate.cancel}
                </Button>
              </div>
            </div>
          </div>
        </Fade>
      </Modal>,
      <Modal key="close-Modal" open={openModal} className={classes.modal} onClose={() => setOpenModal(false)}>
        <Fade in={openModal}>
          <div className={classes.closePaper}>
            <div className={classes.closeticket}>{translate.closeTicketModal}</div>
            <div className={classes.paddingTop} />
            <div className={classes.inline}>
              <Button
                onClick={() => {
                  closeTicketFn(ownTicket.id);
                  close();
                  setOpenModal(false);
                }}
                variant="contained"
                color="secondary"
              >
                {translate.yes}
              </Button>
              <div className={classes.flexGrow} />
              <Button
                variant="contained"
                onClick={() => {
                  close();
                  setOpenModal(false);
                }}
              >
                {translate.cancel}
              </Button>
            </div>
          </div>
        </Fade>
      </Modal>,
    ]
  );
};

InfoModalComponent.propTypes = {
  translate: PropTypes.object.isRequired,
  close: PropTypes.func.isRequired,
  setOrderIdFn: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
};

const mapDispatchToProps = {
  close: () => dispatch => dispatch(toggleInfoModal(false)),
  closeTicketFn: id => dispatch => dispatch(closeTicket(id)),
  setOrderIdFn: (ticketId, orderId) => async dispatch => {
    await dispatch(setOrderId(orderId, ticketId));
  },
};

InfoModalComponent.defaultProps = {
  infoTicket: undefined,
};

const mapStateToProps = state => ({
  open: state.projectmail.infoModalOpen,
  infoTicket: state.projectmail.currentRow,
  translate: state.ui.translate,
});

const InfoModal = connect(
  mapStateToProps,
  mapDispatchToProps
)(InfoModalComponent);

export default InfoModal;
